import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/layout/Footer";

export default function BaseballBroadcast() {
  const IFRAME_HOST_URL = "http://localhost:3000"; // Replace with your actual iframe host URL

  const [parentScrollHeight, setParentScrollHeight] = useState(900); // Initial height

  // const [supportsPWA, setSupportsPWA] = useState(false);
  // const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      event.preventDefault();
      // setSupportsPWA(true);
      // setPromptInstall(event);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin === IFRAME_HOST_URL) {
        if (event.data.type === "scrollToTop") {
          window.scrollTo(0, 0);
        } else if (
          event.data.type === "setScrollHeight" &&
          event.data.scrollHeight &&
          event.data.scrollHeight > parentScrollHeight
        ) {
          setParentScrollHeight(event.data.scrollHeight);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const [fullScreen, setFullScreen] = useState(false);

  // const requestFullScreen = () => {
  //   if (screenfull.isEnabled) {
  //     screenfull.toggle();
  //     setFullScreen(!fullScreen);
  //   } else {
  //     alert("Please enable full screen permission");
  //   }
  // };

  // useEffect(() => {
  //   const handleFullScreenChange = () => {
  //     if (screenfull.isFullscreen) {
  //       setFullScreen(true);
  //     } else {
  //       setFullScreen(false);
  //     }
  //   };

  //   screenfull.on("change", handleFullScreenChange);

  //   return () => {
  //     screenfull.off("change", handleFullScreenChange);
  //   };
  // }, []);

  return (
    <section>
      <Helmet>
        <title>Baseball Broadcast</title>
      </Helmet>
      <iframe
        title="drives-baseball-broadcast-screen"
        id="broadcast-iframe"
        className="mt-12"
        scrolling="no"
        width={"100%"}
        height={parentScrollHeight}
        frameBorder={0}
        allowFullScreen={true}
        allow="autoplay;fullscreen;microphone"
        src={`${process.env.REACT_APP_BASEBALL_IFRAME_HOST_URL}/broadcast/baseball-11064151?host_url=${window.location.origin}&api_key=IDMo1LCgelu3MACEatcLYDYqmRrzZn1Z`}
      />
      <Footer />
    </section>
  );
}
